export default "ALTER TABLE `auto_categorization_rules` ADD `deleted_at` text;";